<div>
  <!-- PRE-STAY GOALS -->
  @if (layer() === 'pre-stay') {
    <div>
      <!-- For advocates -->
      <div class="ft-panel" (click)="onEditGoals([1], 1)">
        <div class="ft-heading ft-text-plus-2">{{ 'flipto.account.Advocates' | translate }}</div>
        @if (campaign()?.goals?.item | campaignGoalFilter: 1 : 1; as advocateGoals) {
          @for (goal of advocateGoals; track goal) {
            <div class="goal-group">
              <div class="ft-label" [innerHTML]="goal | goalName | safeHtml"></div>
              <div [innerHTML]="goal | incentiveName: culture() | safeHtml"></div>
            </div>
          }
          @if (advocateGoals.length === 0) {
            <span class="placeholder ft-placeholder">{{ 'flipto.components.goals.NoGoalsHaveBeenSet' | translate }}</span>
          }
        }
      </div>

      <!-- For warm leads -->
      <div class="ft-panel" (click)="onEditGoals([2], 2)">
        <div class="ft-heading ft-text-plus-2">{{ 'flipto.account.WarmLeads' | translate }}</div>
        @if (campaign()?.goals?.item | campaignGoalFilter: 2 : 1; as socialConnectionsGoals) {
          @for (goal of socialConnectionsGoals; track goal) {
            <div class="goal-group">
              <div class="ft-label" [innerHTML]="goal | goalName | safeHtml"></div>
              <div [innerHTML]="goal | incentiveName: culture() | safeHtml"></div>
            </div>
          }
          @if (socialConnectionsGoals.length === 0) {
            <span class="placeholder">{{ 'flipto.components.goals.NoGoalsHaveBeenSet' | translate }}</span>
          }
        }
      </div>
    </div>
  }

  <!-- POST-STAY GOALS -->
  @if (layer() === 'post-stay') {
    <div>
      <!-- For advocates -->
      <div class="ft-panel" (click)="onEditGoals([3, 4, 6], 1)">
        <div class="ft-heading ft-text-plus-2">{{ 'flipto.account.Advocates' | translate | capitalize }}</div>
        @if (campaign()?.goals?.item | campaignGoalFilter: [3, 4, 6] : 1; as advocateGoals) {
          @for (goal of advocateGoals; track goal) {
            <div class="goal-group">
              <div class="ft-label" [innerHTML]="goal | goalName | safeHtml"></div>
              <div [innerHTML]="goal | incentiveName: culture() | safeHtml"></div>
            </div>
          }
          @if (advocateGoals.length === 0) {
            <span class="placeholder">{{ 'flipto.components.goals.NoGoalsHaveBeenSet' | translate }}</span>
          }
        }
      </div>

      <!-- For warm leads -->
      <div class="ft-panel" (click)="onEditGoals([2], 2)">
        <div class="ft-heading ft-text-plus-2">{{ 'flipto.account.WarmLeads' | translate }}</div>
        @if (campaign()?.goals?.item | campaignGoalFilter: 2 : 1; as socialConnectionsGoals) {
          @for (goal of socialConnectionsGoals; track goal) {
            <div class="goal-group">
              <div class="ft-label" [innerHTML]="goal | goalName | safeHtml"></div>
              <div [innerHTML]="goal | incentiveName: culture() | safeHtml"></div>
            </div>
          }
          @if (socialConnectionsGoals.length === 0) {
            <span class="placeholder">{{ 'flipto.components.goals.NoGoalsHaveBeenSet' | translate }}</span>
          }
        }
      </div>
    </div>
  }

  <!-- group-advocacy GOALS -->
  @if (layer() === 'group-advocacy') {
    <div>
      <!-- For advocates -->
      <div class="ft-panel" [class.read-only]="readOnly()" (click)="onEditGoals([1], 1)">
        <div class="ft-heading ft-text-plus-2">{{ 'flipto.account.Advocates' | translate }}</div>
        @if (campaign()?.goals?.item | campaignGoalFilter: 1 : 1; as advocateGoals) {
          @for (goal of advocateGoals; track goal) {
            <div class="goal-group">
              <div class="ft-label" [innerHTML]="goal | goalName | safeHtml"></div>
              <div [innerHTML]="goal | incentiveName: culture() | safeHtml"></div>
            </div>
          }
          @if (advocateGoals.length === 0) {
            <span class="placeholder">{{ 'flipto.components.goals.NoGoalsHaveBeenSet' | translate }}</span>
          }
        }
      </div>

      <!-- For warm leads -->
      <div class="ft-panel" [class.read-only]="readOnly()" (click)="onEditGoals([2], 2)">
        <div class="ft-heading ft-text-plus-2">{{ 'flipto.account.WarmLeads' | translate }}</div>
        @if (campaign()?.goals?.item | campaignGoalFilter: 2 : 1; as friendsGoals) {
          @for (goal of friendsGoals; track goal) {
            <div class="goal-group">
              <div class="ft-label" [innerHTML]="goal | goalName | safeHtml"></div>
              <div [innerHTML]="goal | incentiveName: culture() | safeHtml"></div>
            </div>
          }
          @if (friendsGoals.length === 0) {
            <span class="placeholder">{{ 'flipto.components.goals.NoGoalsHaveBeenSet' | translate }}</span>
          }
        }
      </div>

      <!-- For attendees -->
      <div class="ft-panel" [class.read-only]="readOnly()" (click)="onEditGoals([7], 2)">
        <div class="ft-heading ft-text-plus-2">{{ 'flipto.components.goals.Attendees' | translate | capitalize }}</div>
        @if (campaign()?.goals?.item | campaignGoalFilter: 7 : 1; as attendeesGoals) {
          @for (goal of attendeesGoals; track goal) {
            <div class="goal-group">
              <div class="ft-label" [innerHTML]="goal | goalName | safeHtml"></div>
              <div [innerHTML]="goal | incentiveName: culture() | safeHtml"></div>
            </div>
          }
          @if (attendeesGoals.length === 0) {
            <span class="placeholder">{{ 'flipto.components.goals.NoGoalsHaveBeenSet' | translate }}</span>
          }
        }
      </div>
    </div>
  }

  <!-- PHOTO-ADVOCACY GOALS -->
  @if (layer() === 'photo-advocacy') {
    <div>
      <div class="ft-panel" (click)="onEditGoals([2], 2)">
        <div class="ft-heading ft-text-plus-2">{{ 'flipto.account.Visitors' | translate | capitalize }}</div>
        @if (campaign()?.goals?.item | campaignGoalFilter: 2 : 1; as socialConnectionsGoals) {
          @for (goal of socialConnectionsGoals; track goal) {
            <div class="goal-group">
              <div class="ft-label" [innerHTML]="goal | goalName | safeHtml"></div>
              <div [innerHTML]="goal | incentiveName: culture() | safeHtml"></div>
            </div>
          }
          @if (socialConnectionsGoals.length === 0) {
            <span class="placeholder">{{ 'flipto.components.goals.NoGoalsHaveBeenSet' | translate }}</span>
          }
        }
      </div>
    </div>
  }
</div>
